<template>
  <div class="main-menu">
    <i-button type="primary" size="small" icon="ios-menu" @click="drawer = true">メインメニュー</i-button>

    <i-drawer placement="left" :closable="false" v-model="drawer" class="main-menu__drawer">
      <a :href="`${mainURL}/top`" class="logo-3nosuke">
        <img src="@/assets/img/logo_3nosuke.png" style="margin: auto; margin-bottom: 8px;" />
      </a>
      <MainMenuList :menu-list="menuList" />
    </i-drawer>
  </div>
</template>

<script>
import { Button, Drawer } from 'view-design'
import MainMenuList from './MainMenuList'
import { getMainMenuList } from '@/util/main_menu'
const MainURL = process.env.VUE_APP_MANAGER_URL
export default {
  components: {
    'i-button': Button,
    'i-drawer': Drawer,
    MainMenuList,
  },
  data() {
    return {
      mainURL: MainURL,
      menuList: [],
      drawer: false,
    }
  },
  created() {
    this.getMainMenuList()
  },
  methods: {
    async getMainMenuList() {
      this.menuList = await getMainMenuList()
    },
  },
}
</script>

<style lang="scss">
.main-menu {
  display: inline-block;
  &__drawer {
    .logo-3nosuke {
      display: flex;
      align-items: center;
      justify-content: left;
      &__text {
        font-size: 22px;
        color: #000;
        vertical-align: middle;
        padding-left: 10px;
        font-weight: 700;
      }
    }
  }
}
</style>
